import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import { TemplateApi } from 'api';
import { TEMPLATE_RESULT_KEY } from 'tanstack-hooks/keys';
import { getObjectMap } from 'util/objectUtils';

export function useTemplateResult(dispensaryId: string, templateId = '', templateResultId = '') {
  const templateApi = new TemplateApi();

  const { data: templateResult, isLoading: isLoadingTemplateResult } = useQuery({
    enabled: !!dispensaryId.length && !!templateId.length && !!templateResultId.length,
    queryKey: [TEMPLATE_RESULT_KEY, dispensaryId, templateId, templateResultId],
    queryFn: () => templateApi.getCrbTemplateResult(dispensaryId, templateId, templateResultId)
  });
  const { templateResultMap } = useMemo(() => {
    if (!templateResult) return { templateResultMap: {} };

    const templateResultMap = getObjectMap(templateResult.requirements_results, 'requirement_id');

    return { templateResultMap };
  }, [templateResult]);

  return { templateResult, templateResultMap, isLoadingTemplateResult };
}
